<template>
  <f7-page class="no-swipeback" login-screen id="login" >
    <a
        href="#login-main-content"
        class="sr-only sr-only-focusable">
      {{ $t('common.skip_to_main_content') }}
    </a>
    <div class="body bgLogin">
      <b-row class="h-100">
        <div class="loginPanel loginHeight">
          <div id="login-main-content" tabindex="-1">
            <h1 class="sr-only">
              {{ $t('loginPage.lgn') }}
            </h1>
            <div>
            <b-row class="panel-heading ajust text-center mb-2rem">
              <b-col cols="2"></b-col>
              <b-col cols="8" class="p-2">
                <b-navbar-brand href="#" class="mr-0 w-80">
                  <img :src="imgVarsLong" alt="MoneyRoadBNPP" class="heritage largescreen w-100">
                  <!--<img :src="imgVarsShort" @click="loadAccueil" alt="MoneyRoad" class="heritage middlescreen">-->
                </b-navbar-brand>
                <h4 class="panel-title" v-if="activationCode">
                  {{ $t('loginPage.sign_in_not_activated') }}
                </h4>
              </b-col>
              <b-col cols="2" class="p-0">
                <nav :aria-label="$t('common.language_navigation')">
                <b-dropdown left class="no-back" toggle-class="border-0 p-0 m-md-2 text-dark z-5" v-model="language">
                  <template slot="button-content">
                    <img class="flag-nav" :src="language === 'FR' ? logoFlagFR : logoFlagEN" alt="logo langue"/><span class="d-none-max-1459px mr-1">{{ labelLanguage }}</span>
                  </template>
                  <b-dropdown-item v-for="option in langOptions" :key="option.value" class="dropdown-item-web-header" @click="languageCountry(option.value)">
                    <img class="flag-nav" v-if="option.value === 'FR'" :src="logoFlagFR" alt="logo Français"/>
                    <img class="flag-nav" v-else :src="logoFlagEN" alt="logo anglais"/>
                    <span>{{option.text}}</span>
                  </b-dropdown-item>
                </b-dropdown>
                </nav>
              </b-col>
            </b-row>
            <div v-if="isLoginPwdAvailable" @keyup.enter="quickLogin()">
              <!--
              <b-row>
                <b-col cols="8" offset="2" class="form-group">
                  <form-write-group-label-input v-model="credentials.Login"
                    inputType="text"
                    :placeholderValue="loginpage_Identifier"
                    :customHeight="'25'"
                    inputLabel="Identifiant">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
              -->
              <!--DRO : Methode la plus simple pour régler le pb de l'affichage du mot de passe-->
              <b-row>
                <b-col cols="8" offset="2" class="form-group">
                  <form-write-group-label-input v-model="credentials.Login"
                    inputType="text"
                    :inputLabel="$t('common.identifier')"
                    inputClass="inputLogin"
                    autocomplete="off">
                  </form-write-group-label-input>
                  <!-- <label>Identifiant</label>
                  <div class="form-control"
                    style="display:flex;height: 40px;">
                    <input v-model="credentials.Login"
                      inputType="text"
                      style="border:none;width: 100%;"
                      :placeholder="loginpage_Identifier">
                    </input>
                  </div> -->
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="8" offset="2" class="form-group">
                  <div>
                    <label for="password">{{$t('common.pwd')}}</label>
                    <div class="d-flex">
                      <input v-model="credentials.Password"
                        id="password"
                        class="form-control inputAccordionForm inputLogin h-30px"
                        :type="passwordFieldType"
                        autocomplete="off">
                      <i class="icon icon-password mt-2 pt-1"
                        :class="[isPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                        @click="toggleVisibility">
                      </i>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col v-if="withPassword" class="form-group">
                  <div class="form-control passwordControl d-flex h-25px">
                    <input v-model="credentials.PasswordRepeat" class="border-0 w-100"
                      :type="passwordFieldType"
                      :placeholder="loginpage_PasswordRepeat"
                      autocomplete="off">
                    <i class="icon icon-password"
                      :class="[isPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                      @click="toggleVisibility">
                    </i>
                  </div>
                </b-col>
              </b-row>
            </div>

            <b-row class="loginButtons" v-if="isLoginPwdAvailable">
              <b-col cols="8" offset="2">
                <b-button variant="primary" size="lg"
                  @click="authUser()">
                  {{ $t('loginPage.lgn_on_login_page') }}
                </b-button>
              </b-col>
            </b-row>

            <b-row class="loginButtons" v-if="isSSOAvailable">
              <b-col cols="8" offset="2">
                <b-button variant="secondary" size="lg"
                  @click="redirectSSO()">
                  {{ $t('loginPage.lgnsso_on_login_page') }}
                </b-button>
              </b-col>
            </b-row>
            <footer class="pt-3 pb-1">
              <b-row>
                <b-col class="xs-12 text-center">
                  <b-col class="d-flex justify-content-center align-items-center">
                    <img class="logoStreammind" :src="logoStreammind" :alt="$t('common.logoStreammind')">
                    <span> {{ $t('common.copyright')}}</span>
                    <span>{{ version }}</span>
                  </b-col>
                </b-col>
              </b-row>
            </footer>
          </div>
          </div>
        </div>
      </b-row>
    </div>
  </f7-page>
</template>

<script>
import _ from 'underscore'
// import moment from 'moment'
import design from '@/design/design.json'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

import StreammindImage from '@/assets/static/images/streammind-text-seul.png'
import FlagFRImage from './../../assets/static/images/fr.png'
import FlagENImage from './../../assets/static/images/gb.png'

export default {
  name: 'CMLogin',
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  props: {
    activationCodePassword: {
      default: 'notWithPassword',
      type: String
    }
  },
  data: () => {
    return {
      activationCode: '',
      connected: false,
      credentials: {
        Biometrics: {
          Voice: 'string',
          Video: 'string',
          Fingerprint: 'string'
        },
        ConnectBy: false,
        Login: '',
        Password: '',
        PasswordRepeat: ''
      },
      defaultService: 'Direct Debit',
      defaultUrl: '/home/',
      design: design.login,
      isLargeScreen: true,
      langOptions: [],
      language: '',
      logoFlagFR: FlagFRImage,
      logoFlagEN: FlagENImage,
      logoStreammind: StreammindImage,
      passwordFieldType: 'password',
      version: '',
      withPassword: false
    }
  },
  computed: {
    isLoginPwdAvailable () {
      return ['ALL','SSOMDP','MDP'].includes(this.$engine.auth.authMode)
    },
    isPasswordFieldHidden () {
      return this.passwordFieldType === 'password'
    },
    isSSOAvailable () {
      return ['ALL','SSOMDP','SSO'].includes(this.$engine.auth.authMode)
    },
    imgVars () {
      return this.design.fontImage
    },
    imgVarsLong () {
      return this.design.headbandLogoLong
    },
    imgVarsShort () {
      return this.design.headbandLogoShort
    },
    labelLanguage () {
      let lang = this.language
      let langOpt = this.langOptions.filter(elem => elem.value.toLowerCase() === lang.toLowerCase())
      let label = this.$t('lang.french')
      if (langOpt.length) {
        label = langOpt[0].value
      }
      return label
    }
  },
  created () {
    var data = this.getJsonFromUrl(window.location.href)
    if (['SSOMDP','SSO'].includes(this.$engine.auth.authMode) && !data.d && !this.$engine.auth.user.get().identifier) {
      this.redirectSSO()
    }
    this.language = this.$i18n.locale.toUpperCase()
    this.langOptions = [
      { value: 'FR', text: this.$t('lang.french')},
      { value: 'EN', text: this.$t('lang.english')}
    ]
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isLargeScreen = false
    }
    this.$bus.$off('refresh-inbox-list-cache')
    this.activationCode = new URL(location.href).searchParams.get('activationCode')
    this.withPassword = new URL(location.href).searchParams.get('withPassword')
    if (this.withPassword === 'true') {
      this.withPassword = true
    } else {
      this.withPassword = false
    }
    if (!this.activationCode) {
      this.activationCode = ''
    }
    this.loginpage_Identifier = this.$i18n.t('common.enter_identifier')
    this.loginpage_PasswordRepeat = this.$i18n.t('common.conf_pwd')
    this.loginpage_UnvalidEmail = this.$i18n.t('errors.unvalid_email_adr')
    if (this.withPassword) {
      this.loginpage_Password = this.$i18n.t('common.new_pwd')
    } else {
      this.loginpage_Password = this.$i18n.t('common.enter_pwd')
    }
    if (this.$engine.versionAPI) {
      this.version = 'Version ' + this.$engine.versionAPI
    } else {
      let that = this
      this.$engine.getApiVersion()
      .then(resp => {
        if (resp.data.version) {
          that.$engine.versionAPI = resp.data.version
          if (that.$engine.versionAPI) {
            that.version = 'Version ' + that.$engine.versionAPI
          }
        }
      })
      .catch(err => {
        errorMessageAlert(err, that, true)
      })
    }
  },
  mounted () {
    if (!this.isLargeScreen) {
      this.$$('.navbar').addClass('deleteNavBar')
    }
    /* TLV 24/08/2020 Si l'utilisateur a déjà une session ouverte et n'est pas en
    * OTP, on le redirige vers la page d'accueil par défaut */
    if (this.$engine.auth.user.get().identifier !== '' && !location.href.includes('OTP')) {
      this.$$('.navbar').removeClass('deleteNavBar')
      this.$bus.$emit('login', true)
      loadPage(this, {url: this.defaultUrl})
    }
    let that = this
    var data = this.getJsonFromUrl(window.location.href)
    if (data.d) {
      let jsonDataStr = atob(data.d)
      setTimeout(function () {
        let jsonData = JSON.parse(jsonDataStr)
        let error = jsonData.code ? jsonData.code : that.$t('errors.error_happened')
        let errorDesc = jsonData.message ? jsonData.message : that.$t('errors.error_fetch_data')
        that.$f7.modal({
          title: error,
          text: errorDesc,
          buttons: [
            {
              text: 'Ok',
              onClick: function () {
                if (['ALL', 'MDP'].includes(that.$engine.auth.authMode)) {
                  window.location.replace(window.location.origin + window.location.pathname);
                }
              }
            }
          ]
        })
      }, 1000)
    }
  },
  methods: {
    connect () {
      /* TLV 18/08/2020
      * On précise ici le nom du service et son URL par défaut associées */
      let that = this
      this.$bus.emit('login', true)
      this.$bus.emit('service:change', this.defaultService)
      this.$bus.emit('refresh-cache-menu')
      this.$f7.hidePreloader()
      this.$$('.panel-overlay').css('z-index', '')
      this.$$('.deleteNavBar').removeClass('deleteNavBar')
      that.connected = true
      loadPage(this, {url: '/home/'})
    },
    authUser () {
      if (this.$$('.modal-in').length) {
        return
      }
      if (this.withPassword) {
        if (this.credentials.Login === '') {
          this.$f7.alert('Login missing', 'Error')
          return
        } else if (this.credentials.Password === '') {
          this.$f7.alert('Password missing', 'Error')
          return
        } else if (this.credentials.PasswordRepeat === '') {
          this.$f7.alert('Password confirm missing', 'Error')
          return
        } else if (this.credentials.Password !== this.credentials.PasswordRepeat) {
          this.$f7.alert('Passwords do not match', 'Error')
          return
        }
      }
      let that = this
      this.$f7.showPreloader(this.$t('loginPage.sign_in_loading'))
      const creds = _.clone(this.credentials)
      creds.ConnectBy = 'lpc'
      if (this.withPassword) {
        creds.WithPassword = '1'
      }
      this.$engine.auth.login(creds)
      .then(() => {
        that.$engine.user.connectBy = 'login-password-capi'
        that.connect()
      })
      .catch(err => {
        that.$f7.hidePreloader()
        if (that.activationCode.length > 0) {
          this.activateAccount(that.activationCode)
        } else {
          errorMessageAlert(err, that)
        }
      })
    },
    getJsonFromUrl (url) {
      if (!url) url = location.href
      var question = url.indexOf('?')
      var hash = url.indexOf('#')
      if (hash === -1 && question === -1) return {}
      if (hash === -1) hash = url.length
      var query = (question === -1 || hash === question + 1) ? url.substring(hash) : url.substring(question + 1, hash)
      var result = {}
      query.split('&').forEach(function (part) {
        if (!part) return
        part = part.split('+').join(' ') // replace every + with space, regexp-free version
        var eq = part.indexOf('=')
        var key = eq > -1 ? part.substr(0, eq) : part
        var val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : ''
        var from = key.indexOf('[')
        if (from === -1) result[decodeURIComponent(key)] = val
        else {
          var to = key.indexOf(']', from)
          var index = decodeURIComponent(key.substring(from + 1, to))
          key = decodeURIComponent(key.substring(0, from))
          if (!result[key]) result[key] = []
          if (!index) result[key].push(val)
          else result[key][index] = val
        }
      })
      return result
    },
    quickLogin () {
      if (!this.connected && this.credentials.Login.length !== 0 && this.credentials.Password.length !== 0 && !this.$$('.modal-in').length) {
        this.authUser()
      }
    },
    activateAccount (code) {
      this.$f7.showPreloader('Activating account')
      let that = this
      if (code !== '') {
        this.$engine.auth.activate(code, this.withPassword, this.credentials.Password)
          .then(response => {
            that.$f7.closeModal()
            that.$f7.hidePreloader()
            that.status = response.status
            if (response.status === 200) {
              this.authUser()
            }
          }).catch(error => {
            that.$f7.hidePreloader()
            errorMessageAlert(error, that)
            // this.showModalActivationCode()
            // that.Dom7('.accountActivationInput2').val(code)
          })
      } else {
        that.$f7.hidePreloader()
        that.$f7.alert('Please enter a valid activation code', 'Incorrect')
        this.showModalActivationCode()
      }
    },
    redirectSSO () {
      window.location = 'loginSSO'
    },
    resetPassword () {
      this.$f7.popup('#cm-user-reset-password-true')
    },
    sendAnotherCode () {
      let that = this
      this.$f7.showPreloader('Sending')
      this.$engine.auth.getNewActivationCode()
        .then(() => {
          that.$f7.hidePreloader()
          that.$f7.alert('New activation code sent!', 'Ok')
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, this)
        })
    },
    showModalActivationCode () {
      let that = this
      that.$$('.blueConfirmationButtonActivationOK2').on('click')
      that.$f7.modal({
        title: 'Activate Account',
        text: 'Please enter your activation code',
        afterText: '<input class="accountActivationInput2" type="text"><p class="blueConfirmationButtonActivationOK2">OK</p>',
        buttons: [
          {
            text: 'Cancel',
            onClick: function () {
              that.$$('.blueConfirmationButtonActivationOK2').off('click')
            }
          },
          {
            text: 'Send new code',
            onClick: function () {
              that.sendAnotherCode()
              that.$$('.blueConfirmationButtonActivationOK2').off('click')
            }
          }
        ]
      })
      that.$$('.blueConfirmationButtonActivationOK2').on('click', function () {
        that.$f7.closeModal()
        that.activateAccount(that.Dom7('.accountActivationInput2').val())
      })
    },
    toggleVisibility () {
      if (this.passwordFieldType === 'password') {
        this.passwordFieldType = 'text'
      } else {
        this.passwordFieldType = 'password'
      }
    },
    handleClickSignIn () {
      let that = this
      // On se conecte via Google
      this.$gAuth.signIn()
      .then(GoogleUser => {
        var gu = GoogleUser.getBasicProfile()
        var FirstName = gu.getGivenName()
        var LastName = gu.getFamilyName()
        var Login = gu.getEmail()
        var Password = gu.getId()
        this.$engine.user.connectBy = 'vue-google-oauth2'
        // est-ce qu'on est inscrit ? pour cela, on essait de se connecter
        that.$f7.showPreloader(this.$t('loginPage.sign_in_loading'))
        const creds = _.clone(that.credentials)
        creds.Login = Login
        creds.Password = Password
        creds.ConnectBy = 'vgo'
        this.$engine.auth.login(creds)
        .then(() => {
          this.connect()
        }).catch(() => {
          // On fail do something
          that.$f7.hidePreloader()
          this.$engine.auth.getLogin(Login, 'lpc')
          .then(() => {
            // Le compte existe en mode lpc.
            that.$f7.alert('The email sent by Google is already present in the database', 'Log in with your account')
          })
          .catch(() => {
            loadPage(that, {url: '/register/' + FirstName + '/' + LastName + '/' + Login + '/' + Password})
          })
        })
      })
      .catch(err => {
        // On fail do something
        if (err === false) {
          this.connect()
        }
      })
    },
    languageCountry (language) {
      this.language = language
      if (language === 'EN') {
        this.$i18n.locale = 'en'
      } else {
        this.$i18n.locale = 'fr'
      }
      this.langOptions = [
        { value: 'FR', text: this.$t('lang.french')},
        { value: 'EN', text: this.$t('lang.english')}
      ]
    }
  }
}
</script>
